import { Component, OnInit } from '@angular/core';
import { Routes, RouterModule, RouterLinkActive, RouterLink } from '@angular/router';

import { LoginService } from '../auth/login/login.service';
import { PortalService } from '../../auth/portal.service';
import { HeaderService } from './header.service';
import { MenuItem, PrimeTemplate } from 'primeng/api';
import { Menubar } from 'primeng/menubar';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [Menubar, PrimeTemplate, RouterLinkActive, RouterLink]
})
export class HeaderComponent implements OnInit {

  constructor(
    public lS: LoginService,
    public pS: PortalService,
    public hS: HeaderService) { }

  ngOnInit() {
    this.hS.refreshMenu();
  }

  isAuthenticated(option = null) {
    return this.hS.isAuthenticated(option);
  }

}